{
  "name": "locumsnest",
  "version": "22.24.0",
  "license": "MIT",
  "scripts": {
    "snapshot-dev": "./.snapshot-dev",
    "ng": "nx",
    "nx": "nx",
    "setup:ca": "sudo cp ca.dev.locumsnest.co.uk /etc/pki/ca-trust/source/anchors/&& sudo update-ca-trust",
    "start": "NODE_OPTIONS=--max_old_space_size=8048 nx run hospital-admin:serve --host=dev.locumsnest.co.uk",
    "start:tools": "NODE_OPTIONS=--max_old_space_size=8048 nx run hospital-admin:serve --configuration=tools",
    "start:debug-prod": "NODE_OPTIONS=--max_old_space_size=8048 nx run hospital-admin:serve --configuration=debug-prod",
    "start:debug-qa": "NODE_OPTIONS=--max_old_space_size=8048 nx run hospital-admin:serve --configuration=debug-qa",
    "start:debug-demo": "NODE_OPTIONS=--max_old_space_size=8048 nx run hospital-admin:serve --configuration=debug-demo",
    "start:debug-dev": "NODE_OPTIONS=--max_old_space_size=8048 nx run hospital-admin:serve --configuration=debug-dev",
    "start:debug-pre-prod": "NODE_OPTIONS=--max_old_space_size=8048 nx run hospital-admin:serve --configuration=debug-pre-prod",
    "start:debug-lab": "NODE_OPTIONS=--max_old_space_size=8048 nx run hospital-admin:serve --configuration=debug-lab",
    "build": "NODE_OPTIONS=--max_old_space_size=8048 nx build",
    "build:prod:hospital-admin": "pnpm build:prod",
    "build:dev": "NODE_OPTIONS=--max_old_space_size=8048 nx build --project=hospital-admin --configuration=dev",
    "build:prod": "NODE_OPTIONS=--max_old_space_size=8048 nx build --project=hospital-admin --configuration production",
    "build:prod:clean": "nx reset && rm -rf dist/apps/hospital-admin && pnpm build:prod",
    "build:qa:hospital-admin": "NODE_OPTIONS=--max_old_space_size=8048 nx build --project=hospital-admin --configuration=qa",
    "deploy:preprod": "pnpm build:prod && ./deploy pre-prod",
    "deploy:staging": "pnpm build:prod && ./deploy staging",
    "deploy:migration": "pnpm build:prod && ./deploy migration",
    "deploy:dev": "pnpm build:dev && ./deploy dev",
    "test": "nx test",
    "lint": "./node_modules/.bin/nx workspace-lint && ng lint",
    "lint:changed": "sh -c '. ./.scripts && lint_changed'",
    "elect:nightly": "sh -c '. ./.scripts && elect_nightly'",
    "compile:changed": "sh -c '. ./.scripts && compile_changed'",
    "e2e": "ng e2e",
    "affected:apps": "nx affected:apps",
    "affected:build": "nx affected:build",
    "affected:e2e": "nx affected:e2e",
    "affected:test": "nx affected:test",
    "affected:lint": "nx affected:lint",
    "affected:dep-graph": "nx affected:dep-graph",
    "nxformat": "nx format:write",
    "format": "prettier '**/*' --write --ignore-unknown",
    "format:changed": "sh -c '. ./.scripts && format_changed'",
    "format:write": "nx format:write",
    "format:check": "nx format:check",
    "release": "sh -c '. ./.scripts && release_sentry' && ./tools/changelog/git-flow-finish.sh",
    "changelog:show": "./tools/changelog/show_changelog.sh"
  },
  "scarfSettings": {
    "enabled": false
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.12",
    "@angular/cdk": "21.2.10",
    "@angular/common": "21.2.12",
    "@angular/compiler": "21.2.12",
    "@angular/core": "21.2.12",
    "@angular/fire": "20.0.1",
    "@angular/forms": "21.2.12",
    "@angular/localize": "21.2.12",
    "@angular/platform-browser": "21.2.12",
    "@angular/platform-browser-dynamic": "21.2.12",
    "@angular/router": "21.2.12",
    "@chamaeleonidae/chmln": "^1.0.1",
    "@ckeditor/ckeditor5-angular": "^11.1.2",
    "@maskito/angular": "^5.2.2",
    "@maskito/core": "^5.2.2",
    "@maskito/kit": "^5.2.2",
    "@ng-bootstrap/ng-bootstrap": "20.0.0",
    "@ng-select/ng-select": "21.8.2",
    "@ngneat/helipopper": "^13.1.2",
    "@ngneat/overview": "8.1.0",
    "@ngrx/effects": "21.1.0",
    "@ngrx/entity": "21.1.0",
    "@ngrx/operators": "21.1.0",
    "@ngrx/router-store": "21.1.0",
    "@ngrx/store": "21.1.0",
    "@ngrx/store-devtools": "21.1.0",
    "@ngxpert/hot-toast": "6.2.0",
    "@nx/angular": "22.7.5",
    "@nx/devkit": "22.7.5",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^10.52.0",
    "@swc/helpers": "0.5.23",
    "angular-file": "^4.0.2",
    "apexcharts": "^5.11.0",
    "awesome-phonenumber": "^7.8.0",
    "bootstrap": "^5.3.8",
    "calendar": "^0.1.1",
    "chroma-js": "^3.2.0",
    "ckeditor5": "^48.0.1",
    "core-js": "3.36.1",
    "file-saver": "^2.0.5",
    "js-video-url-parser": "^0.5.1",
    "lodash-es": "^4.18.1",
    "moment": "^2.30.1",
    "moment-range": "^4.0.2",
    "moment-timezone": "^0.6.2",
    "ng-apexcharts": "^2.4.0",
    "ng-recaptcha": "13.2.1",
    "ngrx-forms": "^8.0.0",
    "ngx-cookie-service": "21.3.1",
    "ngx-infinite-scroll": "21.0.0",
    "ngx-nested-ellipsis": "3.0.3",
    "papaparse": "^5.5.3",
    "rxjs": "~7.8.2",
    "sass": "^1.99.0",
    "storybook": "10.4.1",
    "tippy.js": "^6.3.7",
    "tslib": "^2.7.0",
    "uuid": "^14.0.0",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "2.2.0",
    "@analogjs/vitest-angular": "2.2.0",
    "@angular-devkit/build-angular": "21.2.10",
    "@angular-devkit/core": "21.2.10",
    "@angular-devkit/schematics": "21.2.10",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/aria": "^21.2.10",
    "@angular/build": "21.2.10",
    "@angular/cli": "21.2.10",
    "@angular/compiler-cli": "21.2.12",
    "@angular/language-service": "21.2.12",
    "@chromatic-com/storybook": "^5.2.1",
    "@eslint/eslintrc": "^2.1.1",
    "@eslint/js": "^9.8.0",
    "@ianvs/prettier-plugin-sort-imports": "^4.7.1",
    "@ngrx/eslint-plugin": "21.1.0",
    "@ngrx/schematics": "21.1.0",
    "@nx/eslint": "22.7.5",
    "@nx/eslint-plugin": "22.7.5",
    "@nx/js": "22.7.5",
    "@nx/plugin": "22.7.5",
    "@nx/storybook": "22.7.5",
    "@nx/vite": "22.7.5",
    "@nx/web": "22.7.5",
    "@nx/workspace": "22.7.5",
    "@schematics/angular": "21.2.10",
    "@sentry/cli": "^3.4.1",
    "@storybook/addon-docs": "10.4.1",
    "@storybook/angular": "10.4.1",
    "@storybook/test-runner": "0.24.4",
    "@swc-node/register": "1.11.1",
    "@swc/cli": "0.7.10",
    "@swc/core": "1.15.40",
    "@types/chroma-js": "^3.1.2",
    "@types/file-saver": "^2.0.7",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^25.6.2",
    "@typescript-eslint/utils": "^8.33.1",
    "@vitest/coverage-v8": "^4.1.7",
    "angular-eslint": "21.4.0",
    "dotenv": "17.4.2",
    "eslint": "^9.28.0",
    "eslint-config-prettier": "10.1.2",
    "eslint-plugin-cypress": "^2.15.1",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-jsdoc": "^48.0.6",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-storybook": "10.4.1",
    "eslint-plugin-unused-imports": "^4.1.4",
    "jiti": "^2.7.0",
    "jsdom": "~22.1.0",
    "jsonc-eslint-parser": "^2.1.0",
    "nx": "22.7.5",
    "postcss-svg": "^3.0.0",
    "prettier": "3.5.3",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "ts-node": "10.9.2",
    "tsc-files": "^1.1.4",
    "typescript": "5.9.3",
    "typescript-eslint": "^8.33.1",
    "vite": "^7.3.2",
    "vitest": "^4.1.7"
  },
  "packageManager": "pnpm@11.4.0+sha512.f0febc7e37552ab485494a914241b338e0b3580b93d54ce31f00933015880863129038a1b4ae4e414a0ee63ac35bf21197e990172c4a68256450b5636310968f"
}
